import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { MatChipSelectionChange } from '@angular/material/chips';
import { debounceTime, Subject } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Move } from 'src/app/components/catalogs/catalog-model';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { utils } from 'src/app/modules/libs/utils';
import { TransactionLogService } from 'src/app/services/logs/transaction-log.service';
import { TransactionLog } from 'src/app/services/logs/transaction-logs';
import { RADTableHistory, RadTableConfiguration } from '../cl-image-upload-content/cl-image-upload-content.component';

@Component({
  selector: 'rads-table-history',
  templateUrl: './rads-table-history.component.html',
  styleUrls: ['./rads-table-history.component.scss']
})
export class RadsTableHistoryComponent extends BaseComponent implements OnInit {

  @Input() checklistSerialNo!: string;
  @Input() taskID!: number;
  @Input() configuration?: RadTableConfiguration;

  @Output() selected = new EventEmitter<RADTableHistory>();
  @Output() revertTo = new EventEmitter<TransactionLog>();

  logs: TransactionLog[] = [];
  originalConfiguration?: RadTableConfiguration;

  move = Move;

  index = 0;
  private indexSubject = new Subject<number>();

  constructor(
    protected override injector: Injector,
    private log: TransactionLogService) {
    super(injector);
  }

  ngOnInit(): void {
    this.getHistory();
  }

  getHistory() {
    this.indexSubject.pipe(debounceTime(1500)).subscribe((index) => {
      this.index = index;
      this.select(this.logs[this.index].objectJson ?? '', this.index > 0 ? this.logs[this.index - 1].objectJson : null);
    });

    this.originalConfiguration = this.configuration;
    this.log.GetBySerialNo(this.checklistSerialNo).subscribe(data => {
      this.logs = data.filter(l => l.entityName === 'WFTaskLocal' && l.entityId == this.taskID).sort((a, b) => utils.sort(a.createdOn, b.createdOn));
      if (!this.logs.length) {
        this.alert.info('No history available for this table.');
        return;
      }
      this.index = this.logs.length - 1;
      this.changed(this.index);
      this.logs.forEach(log => {
        if (log.createdBy) {
          log.createdByName = this.users.find(u => u.id === log.createdBy)?.name;
        }
      });
    });
  }


  moveOnHistory(move: Move) {
    switch (move) {
      case Move.FIRST:
        this.index = 0;
        break;
      case Move.LAST:
        this.index = this.logs.length - 1;
        break;
      case Move.NEXT:
        if (this.index < this.logs.length - 1) {
          this.index++;
        }
        break;
      case Move.PREV:
        if (this.index > 0) {
          this.index--;
        }
        break;
    }
    this.select(this.logs[this.index].objectJson ?? '', this.index > 0 ? this.logs[this.index - 1].objectJson : null);
  }

  select(o: string, c?: string | null) {
    const selectedHistory: RADTableHistory = { index: this.index, configuration: this.utils.JSONparse(o), compare: this.utils.JSONparse(c) ?? undefined };

    this.selected.emit(selectedHistory);
  }

  changed(e: any) {
    const value = e;
    this.indexSubject.next(value);
  }

  revert(log: TransactionLog) {
    const confirm = this.dialog.open(YesNoDialogComponent, {
      width: "500px", data: {
        message: this.getMessage("GenericActionConfirmation").description?.replace('{action}', '<b>Revert</b>').replace('{item}', 'this <b>table</b> to the selected update?')
        ,
        icon: "stop",
      },
    });
    confirm.afterClosed().subscribe((data) => {
      if (data) {
        this.revertTo.emit(log);
        this.logs = [];
      }
    });

  }

}

